/* eslint-disable global-require */
import React, { useCallback, useState, useRef } from 'react'
import Modal from 'shared/components/ui/Modal'
import { useDispatch } from 'react-redux'
import { doUploadHistory } from 'actions/attachments'
import { Button } from 'util/ui'

const DebugUploaded = ({ url, onClose }) => {
  return (
    <div>
      <p>{url}</p>
      <br />
      <Button onClick={onClose} primary size="large">
        Close
      </Button>
    </div>
  )
}

const DebugButton = props => {
  const dispatch = useDispatch()
  const [state, setState] = useState({})
  const modal = useRef(null)
  const { stage, data } = state
  const { as } = props
  const Component = as || 'a'

  const startUpload = useCallback(
    async () => {
      modal.current.open()
      setState({ stage: 'uploading', data: null })
      try {
        const response = await dispatch(doUploadHistory())
        // eslint-disable-next-line no-console
        console.log(response)
        setState({ stage: 'uploaded', data: response })
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Debug upload failed', { error: e })
        setState({ stage: 'failed', data: null })
      }
    },
    [dispatch]
  )

  const closeModal = useCallback(() => {
    modal.current.close()
    setState({ stage: 'uploading', data: null })
  }, [])

  const headers = {
    uploading: 'Sending debug data',
    uploaded: 'Debug data uploaded',
    failed: 'Unable to upload, please try again...',
    default: 'Debug data',
  }
  return (
    <Modal
      ref={modal}
      header={headers[stage] || headers.default}
      content={
        // eslint-disable-next-line no-nested-ternary
        data ? (
          <DebugUploaded url={data.url} onClose={closeModal} />
        ) : stage !== 'failed' ? (
          'Uploading...'
        ) : (
          ''
        )
      }
      basic
      cancelButton={false}
      confirmButton={false}
      trigger={
        <Component
          itemKey="debug"
          className="grui"
          as="button"
          type="button"
          onClick={startUpload}
        >
          Send debug info
        </Component>
      }
      mobileWidth="eight"
      tabletWidth="eight"
      desktopWidth="eight"
      wideDesktopWidth="eight"
    />
  )
}

export default DebugButton
